// Client wrappers for the Phase-4 Platform Admin callables:
// platform overview, usage leaderboard, churn risk, cross-tenant phone lookup.
import { call } from './callable';


export interface Overview {
  tenants: { total: number; byStatus: Record<string, number>; new7d: number; new30d: number };
  revenue: { mrrUsd: number; arrUsd: number; paying: number; conversionPct: number };
  volume: {
    messagesThisMonth: number; messagesLastMonth: number; changePct: number | null;
    subscribers: number; liveNumbers: number; connectedNumbers: number;
  };
  alerts: {
    pastDue: number; trialsEndingSoon: number; trialsExpired: number;
    pendingTemplates: number; activeBroadcasts: number; openTickets: number;
  };
}

export interface LeaderRow {
  tenantId: string; tenantName: string; planId: string; status: string;
  thisMonth: number; lastMonth: number; changePct: number | null; subscribers: number;
}

export interface ChurnRow {
  tenantId: string; tenantName: string; planId: string; status: string;
  thisMonth: number; lastMonth: number; subscribers: number;
  reasons: string[]; score: number;
}

export interface ConvMessage {
  id: string;
  direction: string;
  text: string | null;
  status: string | null;
  metaMessageId: string | null;
  error: string | null;
  createdAt: number;
}

export interface ConvMatch {
  tenantId: string;
  tenantName: string;
  subscriber: {
    id: string; phoneE164: string; name: string | null;
    optInStatus: string | null; marketingOptIn: boolean | null;
    labels: string[]; createdAt: number;
  };
  conversationId: string | null;
  messages: ConvMessage[];
}

const padminGrowthC = call<any, any>('padminGrowth');

export const overview = async () => (await padminGrowthC({ action: 'overview' })).data;
export const usageLeaderboard = async (limit?: number) => (await padminGrowthC({ action: 'usageLeaderboard', limit })).data;
export const churnRisk = async () => (await padminGrowthC({ action: 'churnRisk' })).data;
export const findConversation = async (phone: string, messageLimit?: number) =>
  (await padminGrowthC({ action: 'findConversation', phone, messageLimit })).data;
